import type { RouterConfig } from '@nuxt/schema'

import routes from '@/app/router/routes'

export default {
  routes: (_routes) => [
    ...routes,
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@b2ag/not-found'),
    },
  ],
  scrollBehavior(to, _from, _savedPosition) {
    if (to.query.page) {
      return false
    }

    return { left: 0, top: 0 }
  },
} satisfies RouterConfig
